// extracted by mini-css-extract-plugin
export var textInput = "_fn-0";